/*! dependencies: cash */

instant.vimeo = {
  status: {
    apiLoading: false,
    apiLoaded: false
  },
  init: function () {
    instant.vimeo.addCookieInformationEvents();
    cash('body').on('click', '.js-media--vimeo', function () {
      if (!CookieInformation.getConsentGivenFor('cookie_cat_marketing')) {
        alert(instant.settings.youMustGiveCookieConsent);
      }
    });
  },
  bindEvents: function () {
    cash('body').on('mouseenter', '.js-media--vimeo', instant.vimeo.loadApi);
    cash('body').on('click', '.js-media--vimeo', function () {
      var video = cash(this);
      instant.vimeo.startVideo(video);
    });
  },
  startVideo: function (mediaEle) {
    if (instant.vimeo.status.apiLoaded) {
      var iframe = mediaEle.find('iframe'),
        player = new Vimeo.Player(iframe[0]);

      player.play().then(function () {
        if (mediaEle.is('.js-enable-controls')) {
          mediaEle.find('.js-video-overlay').remove();
        } else {
          mediaEle.find('.js-video-overlay').addClass('opacity-0').removeClass('cursor-pointer');
        }
      });
    } else {
      mediaEle.addClass('js-media--vimeo--queued');
      instant.vimeo.loadApi();
    }
  },
  loadApi: function () {
    if (!instant.vimeo.status.apiLoaded && !instant.vimeo.status.apiLoading) {
      var tag = document.createElement('script');
      tag.onload = instant.vimeo.apiLoaded;
      tag.src = 'https://player.vimeo.com/api/player.js';

      document.head.appendChild(tag);

      instant.vimeo.status.apiLoading = true;
    }
  },
  apiLoaded: function () {
    instant.vimeo.status.apiLoaded = true;
    instant.vimeo.status.apiLoading = false;

    cash('.js-media--vimeo--queued').each(function () {
      var video = cash(this);

      instant.vimeo.startVideo(video);
      video.removeClass('js-media--vimeo--queued');
    });
  },
  addCookieInformationEvents: function () {
    window.addEventListener('CookieInformationConsentGiven', function (event) {
      if (CookieInformation.getConsentGivenFor('cookie_cat_marketing')) {
        instant.vimeo.bindEvents();

        var iframes = cash('.js-media--vimeo iframe');
        for (i = 0; i < iframes.length; i++) {
          var iframe = cash(iframes[i]);
          iframe.attr('src', iframe.data('src'));
        }
      }
    }, false);
  }
};